import { TextField, TextFieldProps } from '@mui/material';

interface CustomTextFieldProps {
    isIconVisible: boolean;
    textFieldProps: TextFieldProps;
    InputProps: Record<string, unknown>;
    isError: boolean;
    helperText?: string | null;
}

function CustomTextField({ isIconVisible, textFieldProps = {}, isError, helperText, ...params }: CustomTextFieldProps) {
    const endAdornment = isIconVisible ? params.InputProps?.endAdornment : undefined;

    const InputProps = {
        ...textFieldProps.slotProps?.input,
        ...params.InputProps,
        endAdornment,
    };

    return (
        <TextField
            {...params}
            {...textFieldProps}
            error={isError}
            helperText={helperText}
            slotProps={{ input: InputProps }}
        />
    );
}

export default CustomTextField;
